import { render, staticRenderFns } from "./stepInformationBarTH148.vue?vue&type=template&id=47253da8&scoped=true"
import script from "./stepInformationBarTH148.vue?vue&type=script&lang=js"
export * from "./stepInformationBarTH148.vue?vue&type=script&lang=js"
import style0 from "./stepInformationBarTH148.vue?vue&type=style&index=0&id=47253da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47253da8",
  null
  
)

export default component.exports